var map = {
	"./home.png": "6OLa",
	"./platform.png": "t+DY",
	"./user.png": "D3bw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X29D";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconActive ^\.\/.*\.png$
// module id = X29D
// module chunks = 9